import React from 'react';

import { useTranslation } from 'providers/GILT.provider';
import fromObjectToDataAttributes from 'utils/converters/object/fromObjectToDataAttributes.util';

const SchedulerLoading = ({ message, dataAttributes }) => {
  const { t } = useTranslation();

  return (
    <div data-bem="SchedulerLoading" className="loading-wrap" {...fromObjectToDataAttributes(dataAttributes)}>
      <div className="loading-anim">
        <div className="loading-title">
          <span>{t('scheduler.schedulerLoader.loadingSalonData')}</span>
        </div>
      </div>
      <div data-bem="SchedulerLoading__feedback" className="loading-feedback">
        {message}
      </div>
    </div>
  );
};

// noinspection JSUnusedGlobalSymbols
export default SchedulerLoading;
